import i18n from "../i18n";
import { PricingPlanPeriod } from "../shared/types/pricingPlanTypes";

export const translatePeriodOfTime = (planPeriod: PricingPlanPeriod) => {
  switch (planPeriod) {
    case "month":
      return i18n.t("subscriptions.tarifs.monthlyPeriod");
    case "year":
      return i18n.t("subscriptions.tarifs.yearlyPeriod");
  }
};
